/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  downloadConsumptionReport,
  getConsumptionReport,
  getDateRange,
  getItemMaster,
  getSubModulesByRoleId,
} from "../../../store";

import { CSVLink } from "react-csv";

// config file
import Config from "../../../config/index";

// Cookies
import { Backdrop, CircularProgress, IconButton, Modal } from "@mui/material";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import Cookies from "universal-cookie";

import { addDays, addMinutes, format, subDays } from "date-fns";

import MDCard from "components/MDCard";
import TextError from "utils/TextError";

import CloseIcon from "@mui/icons-material/Close";
import DatePicker from "react-datepicker";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, sm: 400, md: 520 },
  maxHeight: "90vh",
  // Remove or adjust overflowY
  // overflowY: "visible",
  boxShadow: 24,
  p: 2,
  bgcolor: "background.paper",
  borderRadius: 3,
  zIndex: 1400,
};

const Consumption = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getItemMaster,
  getConsumptionReport,
  downloadConsumptionReport,
  downloadConsumptionReportReducer,
  itemMaster,

  getConsumptionReportReducer,
  getDateRange,
  getDateRangeReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  const [selectedFgType, setSelectedFgType] = useState("");
  const [selectedItemCode, setSelectedItemCode] = useState("");

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  // useEffect(() => {
  //   getItemMaster(jwtToken);
  // }, []);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let consumptionReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "",
  );

  let viewConsumption = consumptionReportModule
    ? consumptionReportModule.actionId.includes("")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    if (globalFilter && typeof globalFilter === "object") {
      const cleanedFilter = Object.entries(globalFilter).reduce(
        (acc, [key, value]) => {
          if (value !== "") {
            // Convert qty to number if present
            acc[key] = key === "qty" ? Number(value) : value;
          }
          return acc;
        },
        {},
      );

      setSearchObject(JSON.stringify(cleanedFilter));
    } else {
      setSearchObject("");
    }
  };

  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  // let isoStartDate;
  // let isoEndDate;
  // useEffect(() => {
  //   if (startDate || endDate) {
  //     isoStartDate = new Date(
  //       (startDate ? startDate : new Date()).getTime() -
  //         (startDate ? startDate : new Date()).getTimezoneOffset() * 60000
  //     ).toISOString();

  //     const formatDate = (date) => {
  //       const day = String(date.getDate()).padStart(2, "0");
  //       const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  //       const year = date.getFullYear();
  //       return `${day}-${month}-${year}`;
  //     };

  //     const formattedStartDate = formatDate(new Date(isoStartDate));

  //     isoEndDate = new Date(
  //       (endDate ? endDate : new Date()).getTime() -
  //         (endDate ? endDate : new Date()).getTimezoneOffset() * 60000
  //     ).toISOString();

  //     const formattedEndDate = formatDate(new Date(isoEndDate));
  //   }
  //   // Now you can use both formattedStartDate and formattedEndDate
  //   getMinMaxFailure(
  //     isoStartDate ? isoStartDate : "",
  //     isoEndDate ? isoEndDate : "",
  //     selectedItemCode?.value ? selectedItemCode?.value : "",
  //     jwtToken
  //   );
  // }, [startDate, endDate, selectedItemCode]);

  const [state, setState] = useState({
    columns: [
      { Header: "FG Model code", accessor: "fgModelCode" },

      { Header: "FG Type", accessor: "fgType" },

      { Header: "FG Serial No", accessor: "serialNumber" },

      { Header: "Work Order", accessor: "workOrder" },

      { Header: "Item Code", accessor: "itemCode" },
      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },

      { Header: "Booked SUID", accessor: "bookedSuid" },
      { Header: "Booked Serial No", accessor: "bookedSerialNumber" },
      { Header: "Consumed SUID", accessor: "consumedSuid" },
      { Header: "Consumed Serial No", accessor: "consumedSerialNumber" },
      { Header: "Quantity", accessor: "qty" },

      { Header: "Station", accessor: "station" },
      { Header: "Status", accessor: "status" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getConsumptionReportReducer.consumptionReport.data
      ? getConsumptionReportReducer.consumptionReport.data
      : [];
    setPaginationObj(
      getConsumptionReportReducer?.consumptionReport?.pagination,
    );
    setLoading(getConsumptionReportReducer.loading);
    data?.map((finishedGoods) => {
      let len = desLength;
      const formatDate = new Date(finishedGoods.cd);
      const finishedGoodsObject = {
        itemCode: finishedGoods.itemCode,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: finishedGoods.cd,

        itemDescription: (
          <span style={{ display: "flex" }}>
            <MDTypography
              variant="h6"
              fontWeight="regular"
              style={{ fontSize: "14px" }}
            >
              {finishedGoods.itemDescription
                ? finishedGoods.itemDescription.substring(0, len)
                : ""}
            </MDTypography>
            {finishedGoods?.itemDescription?.length > 35 && (
              <Tooltip
                title={finishedGoods.itemDescription}
                style={{ marginLeft: "0.1rem" }}
              >
                ...
              </Tooltip>
            )}
          </span>
        ),

        fgModelCode: finishedGoods.fgModelCode,
        fgType: finishedGoods.fgType,
        workOrder: finishedGoods.workOrder,
        serialNumber: finishedGoods.serialNumber,
        bookedSuid: finishedGoods.bookedSuid,
        consumedSuid: finishedGoods.consumedSuid,
        bookedSerialNumber: finishedGoods.bookedSerialNumber,
        consumedSerialNumber: finishedGoods.consumedSerialNumber,
        qty: finishedGoods.qty,
        station: finishedGoods.station,
        status: finishedGoods.status,
        // status: (
        //   <button
        //     className={
        //       (finishedGoods.documentStatus === 1 && `status-success`) ||
        //       (finishedGoods.documentStatus === 2 && `status-info`) ||
        //       (finishedGoods.documentStatus === 3 && `status-warning`)
        //     }
        //     style={{ width: "5.5rem" }}
        //   >
        //     {(finishedGoods.documentStatus === 1 && `Open`) ||
        //       (finishedGoods.documentStatus === 2 && `In-Progress`) ||
        //       (finishedGoods.documentStatus === 3 && `Closed`)}
        //   </button>
        // ),
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    // viewFG &&
    setState({ ...state, rows: tempFinishedGoods });
  }, [getConsumptionReportReducer]);

  // const [dateRangeOptions, setDateRangeOptions] = useState([]);

  // useEffect(() => {
  //   let tempItemCodeOptions = [];
  //   let data = getDateRangeReducer.dateRange.data
  //     ? getDateRangeReducer.dateRange.data
  //     : [];

  //   data.map((item) => {
  //     tempItemCodeOptions.push({
  //       label: item.value,
  //       value: item.value,
  //     });
  //   });
  //   setDateRangeOptions(tempItemCodeOptions);
  // }, [getDateRangeReducer]);

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };
  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemCode,
        uom: item.uom,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const handleFgTypeChange = (selectedOption) => {
    setSelectedFgType(selectedOption);
    setSelectedItemCode("");
  };
  const [downloadData, setDownloadData] = useState([]);

  useEffect(() => {
    // Check if the report is loading, if so, clear the previous data
    if (downloadConsumptionReportReducer.loading) {
      setDownloadData([]);
      return;
    }

    // Check if the data is available after loading
    if (
      !downloadConsumptionReportReducer.loading &&
      downloadConsumptionReportReducer.consumptionReport?.data
    ) {
      let tempFinishedGoods = [];
      let data = downloadConsumptionReportReducer.consumptionReport.data || [];

      data.map((finishedGoods) => {
        const formatDate = new Date(finishedGoods.cd);
        const finishedGoodsObject = {
          itemCode: finishedGoods.itemCode,
          itemDescription: finishedGoods.itemDescription,
          fgModelCode: finishedGoods.fgModelCode,
          fgType: finishedGoods.fgType,
          workOrder: finishedGoods.workOrder,
          serialNumber: finishedGoods.serialNumber,
          bookedSuid: finishedGoods.bookedSuid,
          bookedSerialNumber: finishedGoods.bookedSerialNumber,
          consumedSuid: finishedGoods.consumedSuid,
          consumedSerialNumber: finishedGoods.consumedSerialNumber,
          qty: finishedGoods.qty,
          station: finishedGoods.station,

          status: finishedGoods.status,
          // status: (
          //   <button
          //     className={
          //       (finishedGoods.documentStatus === 1 && `status-success`) ||
          //       (finishedGoods.documentStatus === 2 && `status-info`) ||
          //       (finishedGoods.documentStatus === 3 && `status-warning`)
          //     }
          //     style={{ width: "5.5rem" }}
          //   >
          //     {(finishedGoods.documentStatus === 1 && `Open`) ||
          //       (finishedGoods.documentStatus === 2 && `In-Progress`) ||
          //       (finishedGoods.documentStatus === 3 && `Closed`)}
          //   </button>
          // ),

          //  status: (
          //   <button
          //     className={
          //       (picklist.status === 0 && status-created) ||
          //       (picklist.status === 1 && status-warning) ||
          //       (picklist.status === 2 && status-info) ||
          //       (picklist.status === 3 && status-info) ||
          //       (picklist.status === 4 && status-info) ||
          //       (picklist.status === 5 && status-success)
          //     }
          //     style={{ width: "5.5rem" }}
          //   >
          //     {(picklist.status === 0 && Created) ||
          //       (picklist.status === 1 && Released) ||
          //       (picklist.status === 2 && Open) ||
          //       (picklist.status === 3 && Open) ||
          //       (picklist.status === 4 && Open) ||
          //       (picklist.status === 5 && Delivered)}
          //   </button>
          // ),
          //     status2:
          //   (picklist.status === 0 && Created) ||
          //   (picklist.status === 1 && Released) ||
          //   (picklist.status === 2 && Open(Picking)) ||
          //   (picklist.status === 3 && Open(Picked)) ||
          //   (picklist.status === 4 && Open(Delivering)) ||
          //   (picklist.status === 5 && Delivered),
        };
        tempFinishedGoods.push(finishedGoodsObject);
      });

      // Update the state with the new data
      setDownloadData(tempFinishedGoods);
    }
  }, [downloadConsumptionReportReducer]);

  const [selectedDateRange, setSelectedDateRange] = useState("");
  const [customDate, setCustomDate] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);

  const sevenDays = subDays(new Date(), 7).toISOString();
  const thirtyDays = subDays(new Date(), 30).toISOString();
  const ninetyDays = subDays(new Date(), 90).toISOString();

  const [startDate, endDate] = dateRange;

  useEffect(() => {
    if (selectedDateRange?.value === 7) {
      setCustomDate(sevenDays);
      setDateRange([subDays(new Date(), 7), new Date()]);
    }
    if (selectedDateRange?.value === 30) {
      setCustomDate(thirtyDays);
      setDateRange([subDays(new Date(), 30), new Date()]);
    }
    if (selectedDateRange?.value === 90) {
      setCustomDate(ninetyDays);
      setDateRange([subDays(new Date(), 90), new Date()]);
    }
  }, [selectedDateRange]);

  useEffect(() => {
    if (startDate !== null && endDate !== null) {
      setDownloadData([]); // Clear old data before downloading new report

      downloadConsumptionReport(
        addDays(endDate, 1).toISOString(),
        addDays(startDate, 1).toISOString(),
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
    }
  }, [startDate, endDate, pageNo, rowsPerPage, searchObject, jwtToken]);

  const handleDateRangeChange = (selected) => {
    setSelectedDateRange(selected);
  };

  useEffect(() => {
    getConsumptionReport(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [pageNo, rowsPerPage, searchObject]);
  const dateRangeOptions = [
    { label: "Last 7 Days", value: 7 },
    { label: "Last 30 Days", value: 30 },
    { label: "Last 3 Months", value: 90 },
    { label: "Custom date Range", value: "Custom date Range" },
  ];
  const [createCircularModal, setCreateCircularModal] = useState(false);
  const handleCreateCircularModal = () => {
    setTimeout(() => {
      setCreateCircularModal(true);
    }, 500);

    setDownloadData("");
    setCustomDate("");
    setSelectedDateRange("");
    setDateRange([null, null]);
  };
  const handleCreateCloseCircularModal = () => {
    setTimeout(() => {
      setCreateCircularModal(false);
    }, 500);

    setDownloadData("");
    setCustomDate("");
    setSelectedDateRange("");
    setDateRange([null, null]);
  };

  const headers = [
    { label: "FG Modal code", key: "fgModelCode" },

    { label: "FG Type", key: "fgType" },

    { label: "FG Serial No", key: "serialNumber" },
    { label: "Work Order", key: "workOrder" },
    { label: "Item Code", key: "itemCode" },
    { label: "Item Description", key: "itemDescription" },
    { label: "Booked SUID", key: "bookedSuid" },
    { label: "Booked SerialNumber", key: "bookedSerialNumber" },
    { label: "Consumed SUID", key: "consumedSuid" },
    { label: "Consumed SerialNumber", key: "consumedSerialNumber" },
    { label: "Quantity", key: "qty" },
    { label: "Station", key: "station" },
    { label: "Status", key: "status" },
  ];

  const csvLink = {
    filename: "Consumption Report.csv",
    headers: headers,
    data: downloadData,
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", lg: "row" }}
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-3}
                mt={-2}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={12}>
                    <MDBox
                      display="flex"
                      flexDirection={{ xs: "column", lg: "row" }}
                      mt={2}
                    >
                      {/* <MDBox style={{ marginRight: "5px" }}>
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Date Range
                        </MDTypography>
                        <Select
                          
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={130}
                          options={dateRangeOptions}
                          value={selectedDateRange}
                          onChange={handleDateRangeChange}
                        />
                      </MDBox>
                      {selectedDateRange?.value ===
                        "Custom date Range (0-365days)" && (
                        <MDBox
                          
                          style={{ marginRight: "5px" }}
                        >
                          <MDTypography variant="h6">
                            Custom Date Range
                          </MDTypography>

                          <DatePicker
                            className="form-control"
                            dateFormat="dd/MM/yyyy hh:mm aaa"
                            placeholderText="Select date range"
                            onChange={(date) => setDateRange(date)}
                            isClearable={true}
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange={true}
                            
                          />

                         
                        </MDBox>
                      )} */}
                      {/*
                       <MDBox
                        width={{ xs: "125px", lg: "700px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          FG Modal
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={230}
                          // options={itemTypeOptions}
                          // value={selectedItemType}
                          // onChange={handleItemTypeChange}
                        />
                      </MDBox>

                      <MDBox
                        width={{ xs: "125px", lg: "700px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          FG Type
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={230}
                          options={fgTypeOptions}
                          value={selectedFgType}
                          onChange={handleFgTypeChange}
                        />
                      </MDBox>
                      <MDBox
                        width={{ xs: "125px", lg: "700px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Work Order
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={230}
                          // options={itemTypeOptions}
                          // value={selectedItemType}
                          // onChange={handleItemTypeChange}
                        />
                      </MDBox>
                      <MDBox
                        width={{ xs: "125px", lg: "700px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Station
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={230}
                          // options={itemTypeOptions}
                          // value={selectedItemType}
                          // onChange={handleItemTypeChange}
                        />
                      </MDBox>
                      <MDBox
                        width={{ xs: "125px", lg: "1000px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          Item Code/Des
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={380}
                          options={itemCodeOptions}
                          value={selectedItemCode}
                          onChange={handleItemCodeChange}
                        />
                      </MDBox>

                      <MDBox
                        width={{ xs: "125px", lg: "700px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                          SUID
                        </MDTypography>
                        <Select
                          isClearable
                          placeholder="Choose One..."
                          className="select-css-for-filter"
                          maxMenuHeight={380}
                          // options={locationOptions}
                          // value={selectedLocation}
                          // onChange={handleLocationChange}
                        />
                      </MDBox> */}
                      <MDBox
                        display="flex"
                        alignItems="center"
                        marginLeft={1}
                        marginTop={{ xs: 2, lg: 3 }}
                      >
                        <DownloadDataButton
                          style={{ marginLeft: "5px" }}
                          type="button"
                          variant="outlined"
                          color="success"
                          iconOnly
                          tooltip="Download All Data"
                          onClick={handleCreateCircularModal}
                        >
                          <Icon>download</Icon>
                        </DownloadDataButton>
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>

              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  serverSidePagination={true}
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                />
              </MDBox>

              <Modal
                open={createCircularModal}
                onClose={handleCreateCloseCircularModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style} style={{ zIndex: 0 }}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Download Report
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCreateCloseCircularModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    {/* <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    > */}
                    <MDBox style={{ marginRight: "5px", marginBottom: "10px" }}>
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Date Range
                      </MDTypography>
                      <Select
                        // isClearable
                        placeholder="Choose One..."
                        className="select-css-for-filter"
                        maxMenuHeight={130}
                        options={dateRangeOptions}
                        value={selectedDateRange}
                        onChange={handleDateRangeChange}
                      />
                    </MDBox>
                    {selectedDateRange?.value === "Custom date Range" && (
                      <MDBox
                        // width={{ xs: "125px", lg: "700px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6">
                          Custom Date Range
                        </MDTypography>

                        <DatePicker
                          className="form-control"
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Select date range"
                          onChange={(date) => setDateRange(date)}
                          isClearable={true}
                          startDate={startDate}
                          endDate={endDate}
                          selectsRange={true}
                          popperPlacement="right-end"

                          // withPortal
                        />

                        {/* {formik.touched.startDate &&
                            formik.errors.startDate && (
                              <TextError msg={formik.errors.startDate} />
                            )} */}
                      </MDBox>
                    )}
                    {/* <MDBox>
                        <Collapse in={isError}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsError(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccess}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccess(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Circular Created successfully
                          </Alert>
                        </Collapse>
                      </MDBox> */}

                    <MDBox mt={3}>
                      {((selectedDateRange?.value === "Custom date Range" &&
                        dateRange[0] !== null) ||
                        selectedDateRange) &&
                        downloadData.length < 1 && (
                          <TextError msg="No data found" />
                        )}
                      {(selectedDateRange?.value === "Custom date Range" &&
                        dateRange[0] === null) ||
                      downloadData.length < 1 ||
                      !selectedDateRange ? (
                        <MDButton
                          color="success"
                          fullWidth
                          type="button"
                          disabled
                        >
                          Submit
                        </MDButton>
                      ) : (
                        <CSVLink
                          {...csvLink}
                          onClick={() => {
                            // Close modal after 2 seconds
                            setTimeout(() => {
                              handleCreateCloseCircularModal();
                            }, 1000); // 2000ms = 2 seconds
                          }}
                        >
                          <MDButton color="success" fullWidth type="button">
                            Submit
                          </MDButton>
                        </CSVLink>
                      )}
                    </MDBox>
                  </MDBox>
                  {/* </MDBox> */}
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    itemMaster: state.itemMaster,
    getConsumptionReportReducer: state.getConsumptionReportReducer,
    downloadConsumptionReportReducer: state.downloadConsumptionReportReducer,
    getDateRangeReducer: state.getDateRangeReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getConsumptionReport: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getConsumptionReport(pageNo, rowsPerPage, searchObject, jwtToken),
      ),
    downloadConsumptionReport: (
      startDate,
      endDate,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        downloadConsumptionReport(
          startDate,
          endDate,
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),
    getDateRange: (jwtToken) => dispatch(getDateRange(jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(Consumption);
